<template>
  <div :class="classes">
       <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber"
      :page-size="pageSize" ref="table" isAddPageToRouter :isOutside="isOutside">
          <wt-table :list="tableData" :labels="tableLabels" v-loading="loading">
              <slot/>
          </wt-table>
       </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-policy-table'

export default {
  name: 'pt-policy-table',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    totalNumber: {
      type: Number,
      default: 0
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    pageSize: {
      type: Number,
      default: 10
    },
    isOutside: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getTableData (page, next) {
      this.$emit('getTableData', page, next)
    },
    resetPage () {
      this.$refs.table.resetPage()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
